import React from "react";
import ProjectCard from "./ProjectCard";

const Projects = () => {
  return (
    <div id='projects' className='mt-4 text-white'>
      <h1 className='text-2xl font-bold'>Projects</h1>
      <p className='font-light text-gray-400'>Here are some of my Projects</p>

      <div className='flex flex-col md:flex-row mt-4 gap-5'>
        <ProjectCard
          name='Kill Covid'
          issued='2022'
          desc='A game which uses your web camera of your computer to track your index
          finger, which is then used to kill viruses that pops out on to your
          screen. I have used: Python, PyGame, and Open CV
          '
          link='https://github.com/rakibul-mahin/Kill-Corona-Game'
        />
        <ProjectCard
          name='GameVerse (Blog App)'
          issued='2022'
          desc='This is a full stack website for gamers. Here gamers can create an
          account and create posts. Users can also comment on posts. I have used:
          Python, Django, and MySQL
          '
          link='https://github.com/rakibul-mahin/cse370-GameVerse-Blog-App'
        />
        <ProjectCard
          name='GameVerse (Ecom)'
          issued='2022'
          desc='This is an full stack ecommerce shop which sell gaming products like
          keyboard, mouse, headset, controller, console and others. Here customer
          can create an account and buy products. Customers can pay through PayPal.
          I have used: Mongo DB, Express, React JS, Node JS, and Redux
          '
          link=''
        />
        <ProjectCard
          name='Sorting Visualizer'
          issued='2021'
          desc='This shows complete step by step simulation of Bubble Sort algorithm. I
          have used: Python, and Tkinter          
          '
          link='https://github.com/rakibul-mahin/simple-sorting-visualizer'
        />
        <ProjectCard
          name='Diabetes Prediction with SVM'
          issued='2020'
          desc='This is a Machine Learning project, which used Support Vector Machine
          (SVM) to predict if a woman has diabetes or not. I have used: Python,
          Scikit Learn, Numpy, Pandas and Matplotlib        
          '
          link='https://github.com/rakibul-mahin/DiabetesPredictionUsingSVM'
        />
      </div>
    </div>
  );
};

export default Projects;
